<style scoped>
.profile-info-fields > div {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.profile-info-fields {
  padding-top: 20px;
}
.ivu-collapse-content-box
  > .profile-info__content:first-child
  > .profile-info-fields {
  padding-top: 0;
}
.label-info {
  margin-right: 20px;
  font-size: 1em;
}
.profile-info-fields > div > .field {
  width: 100%;
}
.label {
  width: 250px;
}
.ivu-date-picker {
  width: 100%;
}
</style>

<style>
.ivu-collapse-header {
  padding-left: 15px !important;
}
.ivu-collapse-header > i.ivu-icon.ivu-icon-arrow-right-b {
  margin-right: 10px;
}
</style>

<style>
.flag-only > .ivu-row > .ivu-col > .input-default > .ivu-input-group-prepend {
	max-width: 37px;
}

/* .flag-only > .ivu-row > .ivu-col > .input-default > .ivu-input{
	padding-left: 31px;
} */

/* .flag-only > .ivu-row > .ivu-col > .input-dial-code{
  left: 20px !important;
} */
.flag-only > .ivu-row > .ivu-col > .input-dial-code{
  text-align:center;
  left: 0px !important;
  background-color: #eee;
  font-size:14px !important;
  padding:0px !important;
}

.flag-only > .ivu-row > .ivu-col > .input-default > .ivu-input-group-prepend {
  display: none;
}

.flag-only > .ivu-row > .ivu-col > .input-dial-code > .code-border {
  border-right:0px;
}
.flag-only >
  .ivu-row >
  .ivu-col >
  .input-default >
  .ivu-input-group-prepend >
  .ivu-input {
  padding-top:2px !important;
  text-align: center !important;
  background-color:orange !important;
}
</style>


<template>
   <div class="profile-info-fields">
      <!-- <div class="dropdown" v-if="type=='enum'">
         <div class="label">
            <p class="label-info">{{label}}</p>
         </div>
         <div class="field">
            <Select v-model="fieldInfo" filterable @on-change="onUpdate">
               <Option v-for="(item, index) in fieldSelections" :value="item.value" :key="index" :label="item.label">{{ item.label }}</Option>
            </Select>
         </div>
      </div> -->
      <div class="dropdown" v-if="type=='enum'">
         <div class="label">
            <p class="label-info">{{label}}</p>
         </div>
         <div class="field">

            <select v-model="fieldInfo" filterable ref="selectField" v-on:change="onUpdate" class="ivu-select-selection custom-ui-select">
              <option v-for="(item, index) in fieldSelections" :value="item.value" :key="index" :label="item.label">{{ item.label }}</option>
            </select>
         </div>
      </div>
      <div class="dropdown" v-if="type=='region' || type=='province' || type=='country'">
         <div class="label">
            <p class="label-info">{{label}}</p>
         </div>
         <div class="field">

            <select v-model="fieldInfo" filterable ref="selectField" v-on:change="onUpdate" class="ivu-select-selection custom-ui-select">
              <option v-for="(item, index) in fieldSelections" :value="item.name" :key="index" :label="item.name">{{ item.name }}</option>
            </select>
         </div>
      </div>

      <!-- <div class="dropdown" v-if="type=='province'">
         <div class="label">
            <p class="label-info">{{label}}</p>
         </div>
         <div class="field">
            <select v-model="fieldInfo" filterable @on-change="onUpdate" class="ivu-select-selection custom-ui-select">
              <option v-for="(item, index) in fieldSelections" :value="item.name" :key="index" :label="item.name">{{ item.name }}</option>
            </select>
         </div>
      </div> -->
      <div class="checkbox" v-if="type=='array'">
         <div class="label">
            <p class="label-info">{{label}}</p>
            <!-- <small>A private alert mesasge will be sent to you. If a kababayan nearby is in trouble. You are under no obligation to
            take action.</small> -->
            <!-- <small>{{fieldSelections[0].label}}</small> -->
         </div>
         <i-switch v-if="!isMultiple" v-model="fieldInfo" @on-change="onUpdate">
            <Icon type="android-done" slot="open"></Icon>
            <Icon type="android-close" slot="close"></Icon>
         </i-switch>
        <div v-else style="width: 100%;">
          <CheckboxGroup  v-model="fieldValue" @on-change="onUpdate">
            <Checkbox v-for="(option, oIndx) in orderedSelections" v-if="option.label !== 'Others'" style="display:block" :key="oIndx" :label="option.value"></Checkbox>
          </CheckboxGroup>
        </div>
      </div>
      <div class="checkbox" v-if="type=='string' || type=='int' || type=='phone' || type=='textarea'">
         <div class="label">
            <p class="label-info">{{label}}</p>
         </div>
         <div class="field">
            <Input v-model="fieldInfo" :placeholder="label" v-if="type=='string' || type=='int'"
               @on-change="onUpdate(fieldContainer)"></Input>
            <Input v-model="fieldInfo" :placeholder="label" type="textarea"
              v-if="type=='textarea'" :autosize="{minRows: 3,maxRows: 8}"
               @on-change="onUpdate(fieldContainer)"></Input>

              <TelInputLg v-model="fieldInfo" v-if="type=='phone'"
                @onTelInput="onTelInput"
                placeholder="Enter your mobile no."
                ref="telInput"
                class="flag-only"></TelInputLg>
         </div>
      </div>
      <div class="date-time" v-if="type=='datetime'">
         <div class="label">
            <p class="label-info">{{label}}</p>
         </div>
         <div class="field">
            <DatePicker :value="fieldInfo" format="yyyy/MM/dd"
               type="date" placeholder="Select date"></DatePicker>
         </div>
      </div>
      <div v-if="this.slug !== 'display_name'" style="position:relative;padding:5px 0 0;height:10px;margin-bottom:10px">
        <span style="position:absolute;right:0">
          <Checkbox style="width:100%" size="small" v-model="isSet"><small>Display</small></Checkbox></span>
      </div>
   </div>
</template>

<script>
import _ from 'lodash'
import { TelInputLg } from '@/helpers/tel-input';

export default {
  name: 'ProfileInfoFields',
  components: {
    TelInputLg
  },
  props: {
    isMultiple: {
      type: Boolean,
      default: false
    },
    fieldValue: {
      type: [String, Boolean, Array, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    slug: {
      type: String,
      default: ''
    },
    fieldSelections: {
      type: [Array, String, Object],
      default: function () {
        // do something here
      }
    }
  },
  data () {
    return {
      fieldContainer: this.fieldValue,
      checkBoxGroupVal: [],
      hasChanged: false
    }
  },
  computed: {
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    isSet: {
      get() {
        if( typeof this.profileInfo.visible_fields === 'array')
          return (this.profileInfo.visible_fields.indexOf(this.slug) > -1)
        return false;
      },
      set(v) {
        if( !this.profileInfo.visible_fields )
          this.profileInfo.visible_fields = []

        var indx = this.profileInfo.visible_fields.indexOf(this.slug)
        var exist = (indx > -1);

        if (!exist)
          this.profileInfo.visible_fields.push(this.slug)
        else
          this.profileInfo.visible_fields.splice(indx, 1)

        console.log(exist, this.profileInfo.visible_fields)
      }
    },
    orderedSelections: function () {
      return _.orderBy(this.fieldSelections, 'label')
    },
    fieldInfo: {
      get: function () {
        return this.fieldValue
      },
      set: function (val) {
        this.fieldContainer = val
        if (this.fieldContainer != this.fieldValue) this.hasChanged = true
        else this.hasChanged = false
      }
    }
  },
  methods: {
    onUpdate (value) {
      // console.log(this.$refs['selectField'].value)
      if(this.$refs['selectField'])
        this.$emit('saveData', { slug: this.slug, value: this.$refs['selectField'].value })
      else
        this.$emit('saveData', { slug: this.slug, value: value })
    },
    onTelInput(res) {
      if (res.isValid) {
        // this.prescription.mobile_number = res.number;
        this.onUpdate(res.number)
        // this.enableShare();
      } else {

      }
    }
  }
}
</script>
